import { REACT_APP_API_URL } from "../configs/config";
import queryString from "query-string";

const getActivations = async (token: string) => {
  const response = await fetch(`${REACT_APP_API_URL}activation/list`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return await response.json();
};

const getActivationByAppIdAndVersion = async (appId: string, versionCode: number) => {
  const response = await fetch(
    `${REACT_APP_API_URL}activation/${appId}/${versionCode}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return await response.json();
};

const addActivation = async (payload: any, token: string) => {
  const response = await fetch(`${REACT_APP_API_URL}activation/add`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return await response.json();
};

const updateActivation = async (appId: string, versionCode: number, payload: any, token: string) => {
  const response = await fetch(
    `${REACT_APP_API_URL}activation/update/${appId}/${versionCode}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    }
  );
  return await response.json();
};

const deleteActivation = async (appId: string, versionCode: number, token: string) => {
  const response = await fetch(
    `${REACT_APP_API_URL}activation/delete/${appId}/${versionCode}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return await response.json();
};

const searchActivations = async (payload: any, token: string) => {
  const { appId, versionCode, isActive, isAuth, isPayment, pageIndex = 0, pageSize = 10 } = payload;
  
  const queryParams = {
    appId,
    versionCode,
    isActive,
    isAuth,
    isPayment,
    pageIndex,
    pageSize,
  };

  const response = await fetch(
    `${REACT_APP_API_URL}activation/search?${queryString.stringify(queryParams)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return await response.json();
};

const deleteMultipleActivations = async (ids: string[], token: string) => {
  const response = await fetch(`${REACT_APP_API_URL}activation/delete-multiple`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ids }),
  });
  return await response.json();
};

export {
  getActivations,
  getActivationByAppIdAndVersion,
  addActivation,
  updateActivation,
  deleteActivation,
  searchActivations,
  deleteMultipleActivations,
};
